import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/rev-coin/intro_bg.webp";

function Goalspoint() {
  return (
    <section
      className="intro_revcoin text_white bg_purple_color bg_circle_left"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-6 offset-lg-6 offset-md-6"
          >
            <h1>
              Introducing <span style={{ color: "#CBFC01" }}>Goals</span>
            </h1>
            <p>
              Rev Coin is a state-of-the-art crypto stock-based solution created
              by TekRevol, utilizing blockchain technology to revolutionize
              employee benefits. This ground-breaking digital currency allows
              employees to hold shares in the company, nurturing a sense of
              ownership and loyalty.
            </p>
            <p>
              By integrating Rev Coin into the company's network, employees gain
              transparency, control, and the potential for side income and
              rewards.
            </p>
            <p>
              The introduction of Rev Coin marks a momentous breakthrough in
              transforming traditional loyalty programs and empowering employees
              with the advantages of blockchain technology.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Goalspoint;
